import { Callback } from 'src/util/query/models/Callback';

export class ExportTheIdoListViewAsCsvQueryCallBack extends Callback<Blob> {
	public constructor(private readonly applyCsvBlob: (csvBlob: Blob) => void) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
	};

	successCallbackFunction = (successResponse: Blob): void => {
		this.applyCsvBlob(successResponse);
	};
}
